import React, { useEffect, useState } from "react";
import API from "util/Api";
import SnackBar from "components/SnackBar";
import ContainerHeader from "components/ContainerHeader";
import _ from "lodash";
import * as Yup from "yup";
import ReportTable from "components/ReportTable/index";
import EZForm from "components/EZForm";
import { saveAs } from 'file-saver'

const LocationsSummary = (props) => {
    const [config, setConfig] = useState();
    const [summaryTable, setSummaryTable] = useState();
    const [fieldValues, setFieldValues] = useState();
    const [snackBar, setSnackBar] = useState({
        open: false,
        message: "",
        type: "error",
    });

    const validations = Yup.object().shape({
        startDate: Yup.string().required("Required"),
        endDate: Yup.string().required("Required"),
    });

    useEffect(() => {
        API.get("valetLocationsSummary")
            .then((res) => {
                setConfig(res.data.data);
            })
            .catch((err) => {
                setSnackBar({
                    open: true,
                    message: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong",
                    type: "error",
                });
            });
    }, []);

    const handleSubmit = (data, form) => {
        API.post("valetLocationsSummary", JSON.stringify(data))
            .then((res) => {
                setSummaryTable(res.data.data);
                form.setSubmitting(false);
            })
            .catch((err) => {
                console.log("error", err);
                form.setSubmitting(false);
                setSnackBar({
                    open: true,
                    message: err?.response?.data?.msg ? err.response.data.msg : "Something went wrong",
                    type: "error",
                });
            });
    };

    return (
        config &&
        <>
            <ContainerHeader title={config?.title} match={props.match} />
            <EZForm
                fields={Object.values(config.fields)}
                values={fieldValues}
                validationSchema={validations}
                onSubmit={handleSubmit}
            />
            {summaryTable && <ReportTable data={summaryTable} downloadCSVBtn={true} />}
            <SnackBar
                {...snackBar}
                handleClose={() => {
                    setSnackBar(prevState => ({ ...prevState, open: false, message: "" }));
                }}
            />
        </>
    )
}
export default LocationsSummary;